import { call, take, put } from 'redux-saga/effects';
import { get, post } from '../../utils/api';
import settings from '../../utils/settings';

import {
  SYSTEM_LIST_REQUEST,
  DASHBOARD_LIST_REQUEST,
  ACTIVATION_LIST_REQUEST,
  ALERT_LIST_REQUEST,
  SEARCH_LIST_REQUEST,
  SYSTEM_LIST_SUCCESS,
  DASHBOARD_LIST_SUCCESS,
  ACTIVATION_LIST_SUCCESS,
  ALERT_LIST_SUCCESS,
  SEARCH_LIST_SUCCESS,
  REQUEST_FAILURE,
  GET_ENLM_FEEDBACK_REQUEST,
  GET_ENLM_FEEDBACK_SUCCESS,
  GET_ENLM_FEEDBACK_FAILURE,
  ADD_ENLM_FEEDBACK_REQUEST,
  ADD_ENLM_FEEDBACK_SUCCESS,
  ADD_ENLM_FEEDBACK_FAILURE,
  GET_GRID_PROFILE_TOKEN_REQUEST,
  GET_SYSTEM_SAVED_SEARCH_REQUEST,
  GET_SYSTEM_SAVED_SEARCH_SUCCESS,
  GET_SYSTEM_SAVED_SEARCH_FAILURE,
  FILTER_LIST_REQUEST,
  GET_SERVICE_MANAGER_CASES_REQUEST,
  GET_SERVICE_MANAGER_CASES_SUCCESS,
  GET_SERVICE_MANAGER_CASES_FAILURE
} from './constants';

export function* getAllSystemList() {
  while (true) {
    yield take(SYSTEM_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/autocomplete?search_value=_ALL_SITES_&search_type=all`)
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: SYSTEM_LIST_SUCCESS, systemList: result });
      }
    } catch (error) {
      console.log('Saga: getAllSystemList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getAllDashboardList() {
  while (true) {
    yield take(DASHBOARD_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/dashboard_list`)
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: DASHBOARD_LIST_SUCCESS, dashboardList: result });
      }
    } catch (error) {
      console.log('Saga: getAllDashboardList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getAllActivationList() {
  while (true) {
    yield take(ACTIVATION_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/autocomplete?search_value=_ALL_SITES_&search_type=activation`)
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: ACTIVATION_LIST_SUCCESS, activationList: result });
      }
    } catch (error) {
      console.log('Saga: getAllActivationList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getAllAlertList() {
  while (true) {
    yield take(ALERT_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/autocomplete?search_value=_ALL_SITES_&search_type=alert`)
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: ALERT_LIST_SUCCESS, alertList: result });
      }
    } catch (error) {
      console.log('Saga: getAllAlertList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getFilteredList() {
  while (true) {
    const request = yield take(FILTER_LIST_REQUEST);
    try {
      let response;
      const { searchParam, searchType, successCbk = () => { } } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/autocomplete?${encodeURI(searchParam)}&search_type=${encodeURI(searchType)}`)
      });
      if (response.success) {
        const { result } = response;
        if (searchType === 'alert') {
          yield put({ type: ALERT_LIST_SUCCESS, alertList: result });
        } else {
          yield put({ type: ACTIVATION_LIST_SUCCESS, activationList: result });
        }
        successCbk();
      }
    } catch (error) {
      console.log('Saga: getFilteredLists:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getSearchData() {
  while (true) {
    const request = yield take(SEARCH_LIST_REQUEST);
    try {
      let response;
      const { searchValue, searchType } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/site_search_autocomplete?search_value=${encodeURI(searchValue)}&search_type=${encodeURI(searchType)}`)
      });
      if (response.success) {
        yield put({ type: SEARCH_LIST_SUCCESS, searchList: response.result });
      }
    } catch (error) {
      console.log('Saga: getSearchData:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getEnlmFeedback() {
  while (true) {
    yield take(GET_ENLM_FEEDBACK_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl('enlmFeedback'),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_ENLM_FEEDBACK_SUCCESS, enlmFeedbacks: response.result });
      }
    } catch (error) {
      console.log('Saga: getEnlmFeedback:', error);
      yield put({ type: GET_ENLM_FEEDBACK_FAILURE, error: error });
    }
  }
}

export function* addEnlmFeedback() {
  while (true) {
    const request = yield take(ADD_ENLM_FEEDBACK_REQUEST);
    try {
      let response;
      const { body = {}, successCbk } = request.payload;
      response = yield call(post, {
        url: settings.einCoreUrl('enlmFeedback'),
        body: {
          reason: body.reason,
          browser: body.browser,
          os: body.os,
          browser_version: body.browserVersion,
          browser_width: body.browserWidth,
          browser_height: body.browserHeight,
          is_mobile: body.isMobile
        },
        withBearer: true
      });
      if (response.success) {
        yield put({ type: ADD_ENLM_FEEDBACK_SUCCESS });
        successCbk();
      } else {
        yield put({ type: ADD_ENLM_FEEDBACK_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getEnlmFeedback:', error);
      yield put({ type: ADD_ENLM_FEEDBACK_FAILURE, error: error });
    }
  }
}

export function* getGridProfileToken() {
  while (true) {
    const request = yield take(GET_GRID_PROFILE_TOKEN_REQUEST);
    const { serialNumber, authNumber, successCbk = () => { }, failureCbk = () => { } } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/envoy/tpm_token`),
        body: {
          serial_num: serialNumber,
          auth_num: authNumber
        }
      });
      if (response.success) {
        successCbk(response.result.token);
      } else {
        failureCbk(response.result.message || response.result.messages);
      }
    } catch (error) {
      console.log('Saga: getGridProfileToken:', error);
      failureCbk(error);
    }
  }
}

export function* getSystemSavedSearch() {
  while (true) {
    yield take(GET_SYSTEM_SAVED_SEARCH_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('service/enlm_ms/api_internal/account/system_groups_and_saved_searches')
      });
      if (response.success) {
        yield put({ type: GET_SYSTEM_SAVED_SEARCH_SUCCESS, systemSavedSearch: response.result });
      }
    } catch (error) {
      console.log('Saga: getSystemSavedSearch:', error);
      yield put({ type: GET_SYSTEM_SAVED_SEARCH_FAILURE, error: error });
    }
  }
}

export function* getServiceManagerCases() {
  while (true) {
    const request = yield take(GET_SERVICE_MANAGER_CASES_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl('serviceManagerCases'),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_SERVICE_MANAGER_CASES_SUCCESS, serviceManagerCases: response.result || {} });
      } else {
        yield put({ type: GET_SERVICE_MANAGER_CASES_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getServiceManagerCases:', error);
      yield put({ type: GET_SERVICE_MANAGER_CASES_FAILURE, error: error });
    }
  }
}